import {InviteIdentification} from '../interfaces/invite-identification';

export const CLEAR_PENDING_SELECTED_AFFILIATION_CHANGE =
  'CLEAR_PENDING_SELECTED_AFFILIATION_CHANGE';
export const UNLOCK_PENDING_SELECTED_AFFILIATION_CHANGE =
  'UNLOCK_PENDING_SELECTED_AFFILIATION_CHANGE';
export const CLEAR_PENDING_SELECTED_RELATIONSHIP_CHANGE =
  'CLEAR_PENDING_SELECTED_RELATIONSHIP_CHANGE';
export const UNLOCK_PENDING_SELECTED_RELATIONSHIP_CHANGE =
  'UNLOCK_PENDING_SELECTED_RELATIONSHIP_CHANGE';

export const PERSIST_INVITE = 'PERSIST_INVITE';
export interface PersistInvite extends InviteIdentification {}

export const PUSH_NOTIFICATION_RECEIVED = 'PUSH_NOTIFICATION_RECEIVED';
export interface PushNotificationReceived {
  notificationType?: string;
  entityId?: string;
  unreadNotificationsCount?: number | string;
  occurrenceRegisteredAt?: string;
  registeredAt?: string;
}

export const CREATE_VIDEOCALL = 'CREATE_VIDEOCALL';
